var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1352 14.1665C10.9169 14.1665 10.6994 14.0815 10.536 13.9124L7.31686 10.579C7.00186 10.2515 7.00603 9.73238 7.3277 9.41072L10.661 6.07738C10.986 5.75155 11.5135 5.75155 11.8394 6.07738C12.1644 6.40322 12.1644 6.92988 11.8394 7.25572L9.0852 10.0099L11.7344 12.754C12.0544 13.0857 12.0452 13.6132 11.7144 13.9324C11.5519 14.089 11.3435 14.1665 11.1352 14.1665Z",
    fill: "#434656"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.63c1fc9120ac7452e52a818001a4c6ff.svg";
export { ForwardRef as ReactComponent };